import { render, staticRenderFns } from "./EfsMdDiseaseForm.vue?vue&type=template&id=433eb854&scoped=true&"
import script from "./EfsMdDiseaseForm.vue?vue&type=script&lang=js&"
export * from "./EfsMdDiseaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433eb854",
  null
  
)

export default component.exports